// Shared property builder for the per-prospect funnel — all "Staff Funnel: X"
// events. Fires through account.sendEventAsMember keyed on offer.webUserId so
// the prospect threads as a single Amplitude user across all funnel steps,
// from rater (Generated Offer in Rater) through to Policy Purchased. webUserId
// is a deterministic hash of name + address, consistent across rater and
// frontend invocations.
//
// Rejection codes live on quote.offerings (per OFFER_FRAGMENT). The rejections
// array lives on offer. Property names mirror the existing
// `Generated Offer in Rater` event so analysts can filter the same way across
// the full funnel.

export const buildProspectFunnelProperties = ({ offer, session, extraProps = {} }) => {
  const offerings = offer?.quote?.offerings;
  return {
    webUserId: offer?.webUserId,
    offerId: offer?.id,
    staffRep: session?.user?.username,
    isAgency: session?.isAgency,
    affinity: offer?.quote?.global?.affinity || '',
    state: offer?.quote?.correctedAddress?.state,
    leadSource: offer?.quote?.leadSource,
    isAgentSold: offer?.quote?.isAgentSold,
    fromStaff: offer?.quote?.fromStaff,
    simulatedSource: offer?.quote?.simulatedSource,
    rejections: offer?.rejections,
    autoRejectCode: offerings?.autoRejectCode,
    monolineAutoRejectCode: offerings?.monolineAutoRejectCode,
    homeownersRejectCode: offerings?.homeownersRejectCode,
    condoRejectCode: offerings?.condoRejectCode,
    ...extraProps
  };
};

export const trackProspectFunnelEvent = async ({ sendEventAsMember, eventName, offer, session, extraProps = {} }) => {
  const webUserId = offer?.webUserId;
  if (!webUserId || !sendEventAsMember) {
    return;
  }
  return sendEventAsMember({
    eventName,
    userId: webUserId,
    properties: JSON.stringify(buildProspectFunnelProperties({ offer, session, extraProps }))
  });
};
